import React from "react";
import PropTypes from "prop-types";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import { StyledImg, StyledImgIE } from "./styles";
/**
 * Deliver img tag content with performance and accessibility features.
 */
export const ContentfulImage = ({
  clientContext = null,
  context = null,
  title = null,
  defaultImageTitle = "Image",
  url = null,
  width = 200,
  height = 200,
  isCarousel = false,
  imageSettings = `&fit=fill&f=faces&fm=webp&q=90`,
  carouselHeight = 200,
  ampLayout = null,
  imageLoading = null
}) => {
  let { isIE, isMobile } = clientContext;
  let { isAmp } = context;
  let rest = {};

  if (imageLoading) {
    rest.loading = imageLoading;
  }

  // console.log("isAmp, image", isAmp, ampLayout);

  // @TODO Use isMobile to address download size
  if (url) {
    if (isIE === false) {
      if (isAmp === true) {
        return ContentfulImageAmp({
          clientContext,
          context,
          title,
          url,
          width,
          height,
          isCarousel,
          imageSettings,
          carouselHeight,
        });
      }

      return (
        <picture
          style={{
            lineHeight: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: width,
            margin: "0 auto",
          }}
        >
          <source
            type="image/webp"
            data-srcset={`${url}?w=${width}&h=${height}${imageSettings}`} // added height
          />
          <StyledImg
            src={`${url}?w=${width}&h=${height}${`&fit=fill&f=faces&q=90&fm=webp`}`} // added height
            alt={title ? title : defaultImageTitle}
            width={width}
            height={height}
            {...rest}
          />
        </picture>
      );
    } else {
      imageSettings = `&fit=fill&f=faces&q=90`;
      return (
        <StyledImgIE
          src={`${url}?w=${width}&h=${height}${imageSettings}`} // added height
          alt={title ? title : defaultImageTitle}
          maxWidth={width}
          // height={height}
        />
      );
    }
  }
  return null;
};

export const ContentfulImageAmp = ({
  clientContext = null,
  context = null,
  title = null,
  defaultImageTitle = "Image",
  url = null,
  width = 200,
  height = 200,
  isCarousel = false,
  imageSettings = `&fit=fill&f=faces&fm=webp&q=90`, // was &fm=webp&q=80, but is that wrong?
  carouselHeight = 200,
  ampLayout = null,
}) => {
  if (isCarousel) {
    // Note lazyload removed because Amp does not have javascript.
    return (
      <>
        <amp-img
          src={`${url}?w=${width}&h=${height}${imageSettings}`} // Originally didn't have height // @TODO check CDN path
          alt={title ? title : defaultImageTitle}
          layout="responsive"
          width={width / 2}
          height={carouselHeight}
          style={{ width: "100%" }}
        />
      </>
    );
  }
  let correctedUrl = url;
  if (url.indexOf("http") === -1) {
    correctedUrl = `https:${url}`;
  }
  return (
    <>
      <amp-img
        src={`${correctedUrl}?w=${width}&h=${height}${imageSettings}`}
        alt={title ? title : defaultImageTitle}
        layout={ampLayout !== null ? ampLayout : "responsive"}
        width={width / 2}
        height={height / 2}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // maxWidth: width,
          margin: "0 auto",
        }}
      />
    </>
  );
};

export default ContentfulImage;

ContentfulImage.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object,
  /**
   */
  title: PropTypes.string,
  /**
   */
  defaultImageTitle: PropTypes.string,
  /**
   */
  url: PropTypes.string,
  /**
   */
  width: PropTypes.number,
  /**
   */
  height: PropTypes.number,
  /**
   */
  isCarousel: PropTypes.bool,
  /**
   */
  imageSettings: PropTypes.string,
  /**
   */
  carouselHeight: PropTypes.number,
  /**
   Loading property for the image.
   */
  imageLoading: PropTypes.string,
};

ContentfulImageAmp.propTypes = ContentfulImage.propTypes;
